import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import formatNumber from '../utils/formatNumber';
import useNfd from '../hooks/useNfd';
import Link from 'next/link';
import useRaffleOwner from '../hooks/useRaffleOwner';
import ProfileAvatar from './ProfileAvatar';

function RowEntry({ entry, raffle, numberOfEntries }) {
  const raffleOwner = useRaffleOwner(raffle?.owner);
  const { getNfd } = useNfd();
  const [wallet, setWallet] = useState(null);
  const address = entry.address;

  const oddsOfWinning = entry.amount > 0 && `${Math.round((entry.amount / numberOfEntries) * 100)}%`;

  useEffect(() => {
    if (!address) return;

    (async () => {
      try {
        const nfd = await getNfd(address);
        if (nfd) {
          return setWallet(get(nfd, 'name'));
        }
        setWallet(`${address?.slice(0, 4)}...${address?.slice(-4)}`);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [address]);

  return (
    <tr key={entry.address} className='hover:bg-bg'>
      <td className='px-3 py-2 font-medium text-text whitespace-nowrap '>
        <div className=''>
          <Link href={`/profile/${entry.address}`}>
            <a className='flex items-center'>
              {wallet && (
                <div className='flex items-center mr-2'>
                  <ProfileAvatar width={25} address={address} />
                </div>
              )}

              <span>{wallet}</span>
            </a>
          </Link>
        </div>
      </td>
      <td className='py-2 pr-8 font-medium text-center text-text whitespace-nowrap'>
        <div className=''>{formatNumber(entry.amount)}</div>
      </td>
      <td className='py-2 pr-8 font-medium text-center text-text whitespace-nowrap'>
        <div className=''>{oddsOfWinning}</div>
      </td>
      <td className='py-2 pr-8 font-medium text-center text-text whitespace-nowrap'>
        <div className=''>
          {formatNumber(entry.amount * raffle.ticketCost)} {raffleOwner.tokenAbbr}
        </div>
      </td>
    </tr>
  );
}

export default RowEntry;
